import { DownloadConfigInfoType } from '@op/pages/download/types';
import { transCountryText } from '@op/utils';
import { getXHashtagList } from '@opm/services';

function flattenXHashtagDownloadList(response: any) {
  if (!response?.list?.length) {
    return [];
  }

  const groupBy = response.group_by || 'date';
  const rows: Array<{
    date: string;
    country: string;
    rank: number;
    hashtag: string;
    tag: string;
  }> = [];

  response.list.forEach((outer: any) => {
    outer.groups?.forEach((inner: any) => {
      const date = groupBy === 'date' ? outer.group_key : inner.group_key;
      const countryKey =
        groupBy === 'date' ? inner.group_key : outer.group_key;
      const country = transCountryText(countryKey) || countryKey;

      inner.list?.forEach((item: any) => {
        rows.push({
          date,
          country,
          rank: item.rank,
          hashtag: item.hashtag || '',
          tag: item.trending_label || '',
        });
      });
    });
  });

  return rows;
}

export const MarketingHashtagXDownload: DownloadConfigInfoType = {
  type: 'page',
  downloadFunc: async (params: any) => {
    try {
      const res = await getXHashtagList({ data: params });
      const list = flattenXHashtagDownloadList(res);
      return {
        list,
        total: list.length,
      };
    } catch {
      return { list: [], total: 0 };
    }
  },
  columns: () => {
    return [
      { key: 'date', header: 'Date' },
      { key: 'country', header: 'Country' },
      { key: 'rank', header: 'Rank' },
      { key: 'hashtag', header: 'Hashtag' },
      { key: 'tag', header: 'Tag' },
    ];
  },
};
